import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideModule } from 'ng-click-outside';
import { RxPopoverAuthComponent } from './rx-popover-auth.component';
import { RxIconModule } from '../rx-icon/rx-icon.module';

@NgModule({
  imports: [CommonModule, ClickOutsideModule, RxIconModule, RxPopoverAuthComponent],
  exports: [RxPopoverAuthComponent],
})
export class RxPopoverAuthModule {}
